import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import ToastItem from './ToastItem';
import { ToastActions } from '../../actions/toast';
import '../../styles/ToastContainer.css';

class ToastItems extends Component {
  static propTypes = {};

  toasts() {
    let toasts = [];
    let toastsList = this.props.toasts;

    if (!toastsList) return;

    toastsList.forEach((v, k) => {
      toasts.push(<ToastItem toast={v} key={k} />);
    });

    return toasts;
  }

  render() {
    const toastsList = this.toasts();
    return (
      <div className="row col-xs toasts-list">
        <div className="toast-list-div">{toastsList}</div>
      </div>
    );
  }
}

const toastsSelector = state => state.toasts.get('toasts');
const usersSelector = state => state.users.get('users');

const ToastContainerSelector = createSelector(
  [toastsSelector, usersSelector],
  (toasts, users) => {
    return {
      toasts,
      users,
    };
  },
);

@connect(ToastContainerSelector)
export default class ToastContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
  };

  render() {
    const { toasts, dispatch } = this.props;
    return (
      <ToastItems
        toasts={toasts}
        {...bindActionCreators(ToastActions, dispatch)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ToastContainer/ToastContainer.js